import { RelatoriosContent } from '@/shared/components/relatorios/relatorios-content';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { COMISSOES_ROUTES } from '@/features/comissoes/comissoes.constants';

const R = COMISSOES_ROUTES.RELATORIOS;

@Component({
    selector: 'app-comissoes-relatorios-content',
    standalone: true,
    imports: [RouterModule, RelatoriosContent],
    template: `<app-relatorios-content [itens]="itens"></app-relatorios-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComissoesRelatoriosContent {
    /** Relatórios do módulo (routerLink derivam de `COMISSOES_ROUTES.RELATORIOS`). */
    readonly itens: MenuItem[] = [
        {
            label: 'Comissões e Câmaras Técnicas e Grupos de Trabalho',
            data: { descricao: 'Relação das estruturas cadastradas, em três recortes.' },
            items: [
                { label: 'Sintético', routerLink: [R.CCT_GRUPOS, R.SINTETICO], data: { descricao: 'Totais por tipo de estrutura, sem detalhar as comissões.' } },
                { label: 'Analítico', routerLink: [R.CCT_GRUPOS, R.ANALITICO], data: { descricao: 'Uma linha por comissão, com portaria, tipo e situação.' } },
                { label: 'Encerrados', routerLink: [R.CCT_GRUPOS, R.ENCERRADOS], data: { descricao: 'Estruturas extintas, com a portaria de extinção.' } }
            ]
        },
        {
            label: 'Composição de Comissões, Câmaras Técnicas e Grupos de Trabalho',
            routerLink: [R.COMPOSICAO],
            data: { descricao: 'Membros de cada estrutura, com função e período de mandato.' }
        },
        { label: 'Frequência', routerLink: [R.FREQUENCIA], data: { descricao: 'Presença dos membros nas reuniões de uma comissão no ano.' } },
        { label: 'Membros por Unidade da Federação', routerLink: [R.MEMBROS_POR_UF], data: { descricao: 'Distribuição geográfica dos membros por estado.' } },
        {
            label: 'Participação de Membro em Comissões, Câmaras Técnicas e Grupos de Trabalho',
            routerLink: [R.PARTICIPACAO_MEMBRO],
            data: { descricao: 'Todas as estruturas de que um médico participa.' }
        },
        { label: 'Produção de Atas', routerLink: [R.PRODUCAO_ATAS], data: { descricao: 'Atas geradas por período, com a situação de cada uma.' } },
        { label: 'Confirmações de Reunião', routerLink: [R.CONFIRMACOES_REUNIAO], data: { descricao: 'Quem confirmou presença em cada reunião convocada.' } },
        {
            label: 'Requisição de Material Semanal',
            routerLink: [R.REQUISICAO_MATERIAL_SEMANAL],
            data: { descricao: 'Material a providenciar para as reuniões da semana.' }
        }
    ];
}
